import axios from 'axios';

const token = localStorage.getItem('token') || '0';
 const url = process.env.REACT_APP_API_URL;
// Create axios instance
const instance = axios.create({
  baseURL: url, // Adjust if your API routes have a different prefix
});

// Add request interceptor to include token
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  }, 
  (error) => {
    return Promise.reject(error);
  }
);

export default instance;